function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Dialog from "@mui/material/Dialog";
// Limitless imports
import RateFinishMessageFooter from "./RateFinishMessageFooter";
import Fullscreen from "@mui/icons-material/Fullscreen";
const RateFinishMessageOverlay = ({
  classes,
  fullScreen,
  open,
  onCancelDialog,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    disablePortal: true,
    transitionDuration: {
      enter: 500
    },
    classes: {
      paper: classes.paper
    },
    BackdropProps: {
      classes: {
        root: classes.backdrop
      }
    },
    style: {
      position: "absolute"
    },
    onClose: (event, reason) => reason === "backdropClick" && onCancelDialog()
  }, /*#__PURE__*/React.createElement(RateFinishMessageFooter, _extends({}, rest, {
    onCancelDialog: onCancelDialog
  })));
};
const styles = () => ({
  backdrop: {
    position: "absolute"
  },
  paper: {
    margin: 8,
    display: "block",
    background: "unset",
    overflow: "hidden"
  },
  fullScreenPaper: {
    margin: 0
  },
  "@media screen and (min-width: 450px)": {
    backdrop: {
      borderRadius: 12
    },
    paper: {
      borderRadius: 12
    }
  }
});
export default withStyles(styles)(RateFinishMessageOverlay);
RateFinishMessageOverlay.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onCancelDialog: PropTypes.func.isRequired
};